import { canUseDOM } from '../../../utils';
const falseState = {
  failed: true
};
const successState = {
  success: true
};
const storageName = 'top-picks';
const FETCH_TIMEOUT = 30000;
export const deleteTopPicksStorage = () => {
  if (canUseDOM) {
    localStorage.removeItem(storageName);
  }
};
export const getTopPicks = (accessToken, apiGlobal) => {
  return new Promise(function (resolve) {
    const timeout = setTimeout(function () {
      resolve(false);
    }, FETCH_TIMEOUT);
    let myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${accessToken}`);
    myHeaders.append('Content-Type', 'application/json');
    let graphql = JSON.stringify({
      query: '{user{topPicks{itemId}}}',
      variables: {}
    });
    let requestOptions = {
      method: 'POST',
      redirect: 'follow',
      body: graphql,
      headers: myHeaders
    };
    let statusCode = 0;
    fetch(`${apiGlobal}/graphql/user`, requestOptions).then(response => {
      clearTimeout(timeout);
      statusCode = response.status;
      return response.text();
    }).then(result => {
      clearTimeout(timeout);
      let responseObj;
      if (result) {
        responseObj = JSON.parse(result);
      }
      if (statusCode === 200) {
        if (responseObj.data) {
          resolve(responseObj.data.user.topPicks);
        } else {
          resolve(falseState);
        }
      }
      resolve(falseState);
    }).catch(error => {
      resolve(falseState);
    });
  });
};
export const removeTopPicks = (accessToken, topPickIds, apiGlobal) => {
  return new Promise(function (resolve) {
    const timeout = setTimeout(function () {
      resolve(false);
    }, FETCH_TIMEOUT);
    let myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${accessToken}`);
    myHeaders.append('Content-Type', 'application/json');
    let graphql = JSON.stringify({
      query: `mutation removeTopPicks{removeTopPick(itemIds: ${JSON.stringify(topPickIds)} ){itemId,created}}`,
      variables: {}
    });
    let requestOptions = {
      method: 'POST',
      redirect: 'follow',
      body: graphql,
      headers: myHeaders
    };
    let statusCode = 0;
    fetch(`${apiGlobal}/graphql/user`, requestOptions).then(response => {
      clearTimeout(timeout);
      statusCode = response.status;
      return response.text();
    }).then(result => {
      let responseObj;
      if (result) {
        responseObj = JSON.parse(result);
      }
      if (statusCode === 200) {
        if (responseObj.data) {
          resolve(successState);
        }
      }
      resolve(falseState);
    }).catch(error => {
      clearTimeout(timeout);
      resolve(falseState);
    });
  });
};
export const addTopPicks = (accessToken, topPickIds, apiGlobal) => {
  return new Promise(function (resolve) {
    const timeout = setTimeout(function () {
      resolve(false);
    }, FETCH_TIMEOUT);
    let myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${accessToken}`);
    myHeaders.append('Content-Type', 'application/json');
    let graphql = JSON.stringify({
      query: `mutation addTopPicks{addTopPick(itemIds: ${JSON.stringify(topPickIds)} ){itemId,created}}`,
      variables: {}
    });
    let requestOptions = {
      method: 'POST',
      redirect: 'follow',
      body: graphql,
      headers: myHeaders
    };
    let statusCode = 0;
    fetch(`${apiGlobal}/graphql/user`, requestOptions).then(response => {
      clearTimeout(timeout);
      statusCode = response.status;
      return response.text();
    }).then(result => {
      let responseObj;
      if (result) {
        responseObj = JSON.parse(result);
      }
      if (statusCode === 200) {
        if (responseObj.data) {
          resolve(successState);
        }
      }
      resolve(falseState);
    }).catch(error => {
      clearTimeout(timeout);
      resolve(falseState);
    });
  });
};
export const getEmptyTopPicksStorage = list => {
  const newObject = {
    list: list,
    sync: true,
    added: [],
    removed: []
  };
  return newObject;
};
export const getTopPicksStorage = () => {
  if (canUseDOM) {
    if (localStorage.getItem(storageName) === null) {
      const newObject = {
        list: [],
        sync: true,
        added: [],
        removed: []
      };
      localStorage.setItem(storageName, JSON.stringify(newObject));
      return newObject;
    } else {
      return JSON.parse(localStorage.getItem(storageName) || '');
    }
  } else {
    return {
      list: [],
      sync: true,
      added: [],
      removed: []
    };
  }
};
export const setTopPicksStorage = topPicks => {
  if (canUseDOM) {
    if (!topPicks.list) topPicks.list = [];
    localStorage.setItem(storageName, JSON.stringify(topPicks));
  }
};
export const syncTopPicks = (accessToken, apiGlobal) => {
  let topPicks = getTopPicksStorage();
  return new Promise(function (resolve) {
    if (topPicks.added.length) {
      addTopPicks(accessToken, topPicks.added, apiGlobal).then(state => {
        if (state.success) {
          if (topPicks.removed.length) {
            removeTopPicks(accessToken, topPicks.removed, apiGlobal).then(state => {
              if (state.success) {
                resolve(true);
              } else {
                resolve(false);
              }
            });
          } else {
            resolve(true);
          }
        } else {
          resolve(false);
        }
      });
    } else if (topPicks.removed.length) {
      removeTopPicks(accessToken, topPicks.removed, apiGlobal).then(state => {
        if (state.success) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    } else {
      resolve(true);
    }
  });
};